<template>
  <div class="drag-block" @drop.prevent="addFile" @dragover.prevent>
    <div :class="{ hidden: shooting.length === 0 }" class="preview-thumbnails"></div>
    <div v-if="shooting.length === 0" class="inner-drag-block">
      <v-icon size="50" class="mb-10 icon-add-photos">add_to_photos</v-icon>
      <p>{{ $t('addShooting.dragAndDroplabel') }}</p>
      <p>{{ $t('addShooting.or') }}</p>
      <v-btn color="primary" @click="openDialog">{{ $t('addShooting.dragAndDropButton') }}</v-btn>
    </div>
    <div v-if="shooting.length !== 0" class="btn-block-add-photos">
      <v-btn color="primary" @click="openDialog">{{ $t('addShooting.dragAndDropButton') }}</v-btn>
    </div>
    <input
      id="files"
      name="image"
      multiple
      accept="image/*"
      class="dialog-input"
      type="file"
      style="visibility: hidden"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'

Vue.filter('kb', (val) => {
  return Math.floor(val / 1024)
})

export default {
  name: 'DragAndDrop',
  data() {
    return {
      files: []
    }
  },
  computed: {
    ...mapState({
      shooting: (state) => state.newShooting.shooting
    })
  },
  mounted() {
    const input = document.getElementById('files')

    input.addEventListener('change', this.addFile)
  },

  methods: {
    openDialog() {
      document.getElementById('files').click()
    },
    async addFile(e) {
      let droppedFiles = (e.dataTransfer && e.dataTransfer.files) || (e.target && e.target.files)
      let newShooting = [...this.shooting]

      if (!droppedFiles) return
      ;[...droppedFiles].forEach((f) => {
        if (f.type.startsWith('image/')) {
          newShooting.push(f)
        }
      })

      this.$store.commit('UPDATE_NEW_SHOOTING', newShooting)

      for (let i = 0; i < droppedFiles.length; i++) {
        const file = droppedFiles[i]

        if (!file.type.startsWith('image/')) {
          continue
        }

        const preview = document.querySelector('.preview-thumbnails')
        const div = document.createElement('div')
        const close = document.createElement('div')
        const img = document.createElement('img')

        div.classList.add('img-block')
        close.classList.add('close-drag-and-drop')

        img.classList.add('img-thumbnail')

        img.addEventListener('click', this.removeFile)
        close.addEventListener('click', this.removeFile)

        img.file = file

        div.appendChild(img)
        div.appendChild(close)
        preview.appendChild(div)

        const reader = new FileReader()
        reader.onload = (function (aImg) {
          return function (e) {
            aImg.src = e.target.result
          }
        })(img)
        reader.readAsDataURL(file)
      }
    },
    removeFile(event) {
      const input = document.getElementById('files')
      const el = event.target
      const currentShooting = [...this.shooting]
      const file = event.target.parentNode.querySelector('.img-thumbnail').file

      el.parentNode.parentNode.removeChild(el.parentNode)

      let newShooting = currentShooting.filter((f) => {
        return f != file
      })

      this.$store.commit('UPDATE_NEW_SHOOTING', newShooting)
      this.$emit('updateImages', true)
      input.value = ''
    }
  }
}
</script>

<style lang="less" scoped>
.drag-block {
  position: relative;
  border: 1px dashed lightgray;
  height: 500px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.inner-drag-block {
  display: flex;
  flex-direction: column;
}

.preview-thumbnails {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 56px;
}

.btn-block-add-photos {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: rgba(236, 236, 236, 0.24);
  padding: 10px 0;
  -webkit-box-shadow: 3px -2px 10px rgba(50, 50, 50, 0.1);
  -moz-box-shadow: 3px -2px 10px rgba(50, 50, 50, 0.1);
  box-shadow: 3px -2px 10px rgba(50, 50, 50, 0.1);
}

.inner {
  width: 100%;
}

p {
  text-align: center;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.7);
}

.hidden {
  display: none;
}

.dialog-input {
  position: absolute;
}
</style>

<style lang="less">
.img-block {
  height: 130px;
  margin: 0 5px;
  cursor: pointer;
  float: left;
  position: relative;
}

.img-thumbnail {
  width: auto;
  height: 100%;
  transition: transform 0.2s;
  padding: 5px;
  border-radius: 10px;
}

.image-error {
  border: 1px solid red;
}

.img-block .content-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: none;
  color: #fff;
  padding: 5px;
  border-radius: 10px;
  -webkit-transition: all 0.4s ease-in-out 0s;
  -moz-transition: all 0.4s ease-in-out 0s;
  transition: all 0.4s ease-in-out 0s;
}
.img-block:hover .img-thumbnail {
  filter: brightness(0.5);
}

.img-block:hover .close-drag-and-drop {
  opacity: 1;
}

.close-drag-and-drop {
  position: absolute;
  opacity: 0;
  left: 50%;
  top: 50%;
  width: 42px;
  height: 42px;
  transform: translate(-50%, -50%);
}

.close-drag-and-drop:before,
.close-drag-and-drop:after {
  position: absolute;
  left: 20px;
  content: ' ';
  height: 43px;
  width: 2px;
  background-color: #fff;
}
.close-drag-and-drop:before {
  transform: rotate(45deg);
}
.close-drag-and-drop:after {
  transform: rotate(-45deg);
}
</style>
